module.exports = __webpack_public_path__ + "static/12.2-df542f2539137c1c13e406d80c7b47e2.jpg";